import { GetContextMenuItemsParams } from 'ag-grid-community'
import IconCopy from 'assets/icons/copy.svg'
import { processDataFromClipboard } from '../../utils/processDataFromClipboard'

export const copyValueMenuItem = (params: GetContextMenuItemsParams) => {
  return {
    name: 'Copy cell value',
    action: () => {
      navigator.clipboard.writeText(processDataFromClipboard(params) ?? '')
    },
    icon: `<img src="${encodeURI(IconCopy)}" alt="Copy" role="img" aria-label="Copy cell value icon" onerror="this.style.display='none'" />`,
  }
}
